module.exports = __webpack_public_path__ + "static/media/bell-beaker_EBA_wales_preview.4b45c599.png";